var _defs, _g, _g2, _g3, _g4, _g5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlatChartG01(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "DashboardMehrobo",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1034.43 903",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e5cdcc;}.cls-2{fill:#518f6a;}.cls-3{fill:#609e7b;}.cls-4{fill:#99e5bc;}.cls-5{fill:#72b28c;}.cls-6{fill:#a94f4f;}.cls-7{fill:#c66767;}.cls-8{fill:#ce7272;}.cls-9{fill:#904041;}.cls-10{fill:#b8615c;}.cls-11{fill:#8c6956;}.cls-12{fill:#e1c9b8;}.cls-13{fill:#c0a28f;}.cls-14{fill:#fff;}.cls-15{fill:#eef3f7;}.cls-16{fill:#ff960c;}.cls-17{fill:#cfd819;}.cls-18{fill:#62a3ff;}.cls-19,.cls-20,.cls-22,.cls-25,.cls-29,.cls-31,.cls-39{fill:none;}.cls-19,.cls-22,.cls-23{stroke:#46da93;}.cls-19,.cls-20,.cls-22,.cls-23,.cls-24,.cls-25,.cls-26,.cls-28,.cls-29,.cls-31,.cls-39,.cls-50{stroke-miterlimit:10;}.cls-19,.cls-25,.cls-29{stroke-width:5px;}.cls-20{stroke:#afafaf;stroke-width:3px;}.cls-21,.cls-23{fill:#46da93;}.cls-22,.cls-23,.cls-26,.cls-28,.cls-31{stroke-width:4px;}.cls-24,.cls-28,.cls-30{fill:#f90368;}.cls-24{stroke:#999;stroke-width:2px;}.cls-25,.cls-26{stroke:#ff7900;}.cls-26,.cls-27{fill:#ff7900;}.cls-28,.cls-29,.cls-31{stroke:#f90368;}.cls-32{fill:#fda386;}.cls-33{fill:#002440;}.cls-34{fill:#aabce4;}.cls-35{fill:#8fa8cc;}.cls-36{fill:#d6dcf2;}.cls-37{fill:#444a6c;}.cls-38{fill:#262e4f;}.cls-39{stroke:#071649;}.cls-40{fill:#071649;}.cls-41{fill:#2b2b2b;}.cls-42{fill:gray;}.cls-43{fill:#777;}.cls-44{fill:#ee876c;}.cls-45{fill:#082d4b;}.cls-46{fill:#f34627;}.cls-47{fill:#ed8e75;}.cls-48{fill:#e77359;}.cls-49{fill:#000b2f;}.cls-50{fill:#fcfafa;stroke:#ff5c60;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ground"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 526.6,
    cy: 870.5,
    rx: 500.5,
    ry: 32.5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Flower"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_7",
    "data-name": "Layer 7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M154.51,763s-6.3-7.7-7-10.5-2.8-11.37,3.5-14.08,23.08-10.4,23.15-21.19c.06-8.83-7.76-16.49-25.25-22.79s-.7-27.28,2.52-28.52c.3-.11,12.86-7.33,13.21-28.23S149.25,606.28,144,604.18c-7-2.79-27.28-1.4-25.88,28.68s-19.59,69.26-19.59,69.26L109,732.9l14,32.18Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M95.05,763.68s-30.78-1.4-35-14.69c-4-12.66,1.4-13.29,7-18.89,2.47-2.47-.7-13.29-16.09-18.89S3.41,704.92,1.31,691.62s-5.6-25,25.18-35c21.69-7,7-27.28-8.39-42.67A39.53,39.53,0,0,1,6.91,577.6c.7-2.8,4.19-11.89,18.88-12.59,16.9-.8,36.38,46.87,37.08,50.37s6.29,9.79,11.89,6.29,16.79-14,27.28-10.49c14.3,4.76,17.38,16.8,18.89,29.38,2.1,17.49-7.7,50.37-12.59,58.06-5.59,8.77,5.57,18.3,9.09,18.89,4.2.7,17.49-2.1,19.59,10.49,1.15,6.93-2.81,35.66-11.55,38.12S95.05,763.68,95.05,763.68Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_8",
    "data-name": "Layer 8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M30,604.91c16.19,14.71,28.89,32.74,39.16,52,11.24,21.07,19.67,43.5,27.6,66a347,347,0,0,1,11.48,39.87,3,3,0,0,0,5.79-1.6c-5.36-24-13.64-47.26-22.73-70.08-8.64-21.71-18.7-43-32.27-62.1a175.19,175.19,0,0,0-24.79-28.29,3.07,3.07,0,0,0-4.24,0,3,3,0,0,0,0,4.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M141,634.75a150.27,150.27,0,0,0-5.41,15.17c-1.69,5.13-3.32,10.27-4.85,15.45A286.32,286.32,0,0,0,123.14,697c-1.07,6.1-1.9,12.25-2.41,18.43a3,3,0,0,0,3,3,3.07,3.07,0,0,0,3-3c1.75-20.92,7.34-41.28,13.8-61.18q1.4-4.29,2.84-8.58c.89-2.64,1.7-5.34,2.85-7.88a3.09,3.09,0,0,0-1.08-4.1,3,3,0,0,0-4.1,1.08Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M60.07,788.16a121.54,121.54,0,0,0,28,88.84h50.23a127.09,127.09,0,0,0,23.92-49.67,126,126,0,0,0,2.8-39.17"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_5",
    "data-name": "Layer 5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M155.57,805.4c.75,19.56-8.39,37.4-17.14,54.28-1.33,2.57,2.55,4.85,3.89,2.27,9.11-17.58,18.53-36.19,17.75-56.55-.12-2.89-4.62-2.9-4.5,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M163.56,766.52c1.75,4.71.77,9.71-.21,14.48a1.55,1.55,0,0,0,1.05,1.85,1.51,1.51,0,0,0,1.84-1.05c1.09-5.27,2.15-10.87.22-16.08a1.54,1.54,0,0,0-1.85-1.05,1.52,1.52,0,0,0-1.05,1.85Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M61.94,821.74c32.24-20.16,73.59-28.6,103.06-28.68v-6.3H59.48C57.83,795.5,58.75,812.23,61.94,821.74Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_4",
    "data-name": "Layer 4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M53.08,762.28a22.25,22.25,0,0,0-3.5,11.19,22.91,22.91,0,0,0,4.89,14.69l116.83-.7a22.42,22.42,0,0,0,4.19-14.69,22,22,0,0,0-4.19-11.19Z"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Board"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 356.25,
    y: 707.71,
    width: 11.01,
    height: 184.45,
    transform: "translate(501.59 -66.79) rotate(33.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 688.25,
    y: 707.71,
    width: 11.01,
    height: 184.45,
    transform: "translate(1713.78 1084.1) rotate(146.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 242.1,
    y: 679,
    width: 558,
    height: 49
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 242.1,
    y: 679,
    width: 558,
    height: 30
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 242.1,
    y: 685,
    width: 558,
    height: 19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 216.1,
    width: 610,
    height: 688
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Charts"
  }, /*#__PURE__*/React.createElement("image", {
    width: 159,
    height: 146,
    transform: "translate(171.1 301) scale(0.92)",
    xlinkHref: "Mehrobo/Pics/boy.png"
  }), /*#__PURE__*/React.createElement("image", {
    width: 159,
    height: 146,
    transform: "translate(182.1 534) scale(0.87 0.89)",
    xlinkHref: "Mehrobo/Pics/girl2.png"
  }), /*#__PURE__*/React.createElement("image", {
    width: 159,
    height: 146,
    transform: "translate(184.1 72) scale(0.89)",
    xlinkHref: "Mehrobo/Pics/girl.png"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-16",
    cx: 251.1,
    cy: 663,
    rx: 23,
    ry: 4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-17",
    cx: 251.1,
    cy: 201,
    rx: 30.5,
    ry: 6.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-18",
    cx: 250.6,
    cy: 436,
    rx: 24.5,
    ry: 7
  }), /*#__PURE__*/React.createElement("g", {
    id: "Green"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_34",
    "data-name": "Layer 34"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-19",
    cx: 250.6,
    cy: 129.5,
    r: 80
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_32",
    "data-name": "Layer 32"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-20",
    x1: 356.6,
    y1: 184.5,
    x2: 664.05,
    y2: 184.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-20",
    x1: 679.6,
    y1: 66.5,
    x2: 696.56,
    y2: 66.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-20",
    x1: 688.08,
    y1: 66.5,
    x2: 688.08,
    y2: 184.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-20",
    x1: 697.1,
    y1: 185.5,
    x2: 679.6,
    y2: 185.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-20",
    x1: 695.56,
    y1: 107.5,
    x2: 680.1,
    y2: 107.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-20",
    x1: 696.1,
    y1: 145.81,
    x2: 680.6,
    y2: 145.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 355.1,
    y: 200,
    width: 26,
    height: 12
  }))), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-22",
    points: "355.1 164.32 384.1 137 460.82 137 499.1 99 558.35 99 584.1 75 662.01 75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "663.1 68 663.15 82 672.1 75.04 663.1 68"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_41",
    "data-name": "Layer 41"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 385.1,
    y1: 142,
    x2: 385.1,
    y2: 147.47
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 385.1,
    y1: 151.04,
    x2: 385.1,
    y2: 158.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 385.1,
    y1: 162.79,
    x2: 385.1,
    y2: 169.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 385.1,
    y1: 173.51,
    x2: 385.1,
    y2: 179.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 461.1,
    y1: 142,
    x2: 461.1,
    y2: 147.47
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 461.1,
    y1: 151.04,
    x2: 461.1,
    y2: 158.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 461.1,
    y1: 162.79,
    x2: 461.1,
    y2: 169.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 461.1,
    y1: 173.51,
    x2: 461.1,
    y2: 179.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 499.1,
    y1: 142,
    x2: 499.1,
    y2: 147.47
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 499.1,
    y1: 151.04,
    x2: 499.1,
    y2: 158.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 499.1,
    y1: 162.79,
    x2: 499.1,
    y2: 169.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 499.1,
    y1: 173.51,
    x2: 499.1,
    y2: 179.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 499.1,
    y1: 110,
    x2: 499.1,
    y2: 115.47
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 499.1,
    y1: 119.04,
    x2: 499.1,
    y2: 126.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 499.1,
    y1: 130.79,
    x2: 499.1,
    y2: 137.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 499.1,
    y1: 141.51,
    x2: 499.1,
    y2: 147.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 558.1,
    y1: 142,
    x2: 558.1,
    y2: 147.47
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 558.1,
    y1: 151.04,
    x2: 558.1,
    y2: 158.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 558.1,
    y1: 162.79,
    x2: 558.1,
    y2: 169.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 558.1,
    y1: 173.51,
    x2: 558.1,
    y2: 179.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 558.1,
    y1: 110,
    x2: 558.1,
    y2: 115.47
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 558.1,
    y1: 119.04,
    x2: 558.1,
    y2: 126.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 558.1,
    y1: 130.79,
    x2: 558.1,
    y2: 137.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 558.1,
    y1: 141.51,
    x2: 558.1,
    y2: 147.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 586.1,
    y1: 142,
    x2: 586.1,
    y2: 147.47
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 586.1,
    y1: 151.04,
    x2: 586.1,
    y2: 158.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 586.1,
    y1: 162.79,
    x2: 586.1,
    y2: 169.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 586.1,
    y1: 173.51,
    x2: 586.1,
    y2: 179.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 586.1,
    y1: 110,
    x2: 586.1,
    y2: 115.47
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 586.1,
    y1: 119.04,
    x2: 586.1,
    y2: 126.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 586.1,
    y1: 130.79,
    x2: 586.1,
    y2: 137.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 586.1,
    y1: 141.51,
    x2: 586.1,
    y2: 147.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 586.1,
    y1: 87,
    x2: 586.1,
    y2: 92.47
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 586.1,
    y1: 96.04,
    x2: 586.1,
    y2: 103.7
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Orange"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_34_copy",
    "data-name": "Layer 34 copy"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-25",
    cx: 250.6,
    cy: 361.5,
    r: 80
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "663.1 328 663.15 342 672.1 335.04 663.1 328"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_32_copy",
    "data-name": "Layer 32 copy"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-20",
    x1: 356.6,
    y1: 416.5,
    x2: 664.05,
    y2: 416.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-20",
    x1: 679.6,
    y1: 298.5,
    x2: 696.56,
    y2: 298.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-20",
    x1: 688.08,
    y1: 298.5,
    x2: 688.08,
    y2: 416.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-20",
    x1: 697.1,
    y1: 417.5,
    x2: 679.6,
    y2: 417.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-20",
    x1: 695.56,
    y1: 339.5,
    x2: 680.1,
    y2: 339.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-20",
    x1: 696.1,
    y1: 377.81,
    x2: 680.6,
    y2: 377.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 355.1,
    y: 432,
    width: 26,
    height: 12
  })), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-25",
    points: "355.1 393.08 371.46 377.5 461.84 377.81 486.1 346 559.1 348 589.1 335 662.1 335"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_41_copy",
    "data-name": "Layer 41 copy"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 374.1,
    y1: 385,
    x2: 374.1,
    y2: 390.47
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 374.1,
    y1: 394,
    x2: 374.1,
    y2: 399.47
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 374.1,
    y1: 404,
    x2: 374.1,
    y2: 409.47
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 463.1,
    y1: 383,
    x2: 463.1,
    y2: 388.47
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 463.1,
    y1: 393.51,
    x2: 463.1,
    y2: 399.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 463.1,
    y1: 403.51,
    x2: 463.1,
    y2: 409.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 488.1,
    y1: 392,
    x2: 488.1,
    y2: 397.47
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 488.1,
    y1: 404,
    x2: 488.1,
    y2: 409.47
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 488.1,
    y1: 383,
    x2: 488.1,
    y2: 388.47
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 488.1,
    y1: 375,
    x2: 488.1,
    y2: 380.47
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 488.1,
    y1: 355,
    x2: 488.1,
    y2: 360.47
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 488.1,
    y1: 364.04,
    x2: 488.1,
    y2: 371.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 557.1,
    y1: 403.51,
    x2: 557.1,
    y2: 409.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 557.1,
    y1: 393.51,
    x2: 557.1,
    y2: 399.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 557.1,
    y1: 384.51,
    x2: 557.1,
    y2: 390.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 557.1,
    y1: 373.51,
    x2: 557.1,
    y2: 379.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 557.1,
    y1: 354.51,
    x2: 557.1,
    y2: 360.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 557.1,
    y1: 364.51,
    x2: 557.1,
    y2: 370.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 591.1,
    y1: 391.51,
    x2: 591.1,
    y2: 397.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 591.1,
    y1: 380.51,
    x2: 591.1,
    y2: 386.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 591.1,
    y1: 369,
    x2: 591.1,
    y2: 374.47
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 591.1,
    y1: 402.51,
    x2: 591.1,
    y2: 408.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 591.1,
    y1: 346,
    x2: 591.1,
    y2: 351.47
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 591.1,
    y1: 355.04,
    x2: 591.1,
    y2: 362.7
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Red"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "642.1 571 642.15 585 651.1 578.04 642.1 571"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_34_copy_2",
    "data-name": "Layer 34 copy 2"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-29",
    cx: 250.6,
    cy: 587.5,
    r: 80
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_32_copy_2",
    "data-name": "Layer 32 copy 2"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-20",
    x1: 356.6,
    y1: 642.5,
    x2: 664.05,
    y2: 642.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-20",
    x1: 679.6,
    y1: 524.5,
    x2: 696.56,
    y2: 524.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-20",
    x1: 688.08,
    y1: 524.5,
    x2: 688.08,
    y2: 642.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-20",
    x1: 697.1,
    y1: 643.5,
    x2: 679.6,
    y2: 643.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-20",
    x1: 695.56,
    y1: 565.5,
    x2: 680.1,
    y2: 565.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-20",
    x1: 696.1,
    y1: 603.81,
    x2: 680.6,
    y2: 603.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 355.1,
    y: 658,
    width: 26,
    height: 12
  })), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-31",
    points: "355.1 622.02 397.1 610 470.1 611 539.97 594.35 595.1 578 640.74 578"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 399.1,
    y1: 616,
    x2: 399.1,
    y2: 621.17
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 469.1,
    y1: 616,
    x2: 469.1,
    y2: 621.17
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 563.1,
    y1: 596,
    x2: 563.1,
    y2: 601.17
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 596.1,
    y1: 586,
    x2: 596.1,
    y2: 591.17
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 596.1,
    y1: 595,
    x2: 596.1,
    y2: 600.17
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 596.1,
    y1: 605,
    x2: 596.1,
    y2: 610.17
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 596.1,
    y1: 614,
    x2: 596.1,
    y2: 619.17
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 596.1,
    y1: 624,
    x2: 596.1,
    y2: 629.17
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 596.1,
    y1: 633,
    x2: 596.1,
    y2: 638.17
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 563.1,
    y1: 605,
    x2: 563.1,
    y2: 610.17
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 563.1,
    y1: 614,
    x2: 563.1,
    y2: 619.17
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 563.1,
    y1: 624,
    x2: 563.1,
    y2: 629.17
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 563.1,
    y1: 633,
    x2: 563.1,
    y2: 638.17
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 469.1,
    y1: 625,
    x2: 469.1,
    y2: 630.17
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 469.1,
    y1: 634,
    x2: 469.1,
    y2: 639.17
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 399.1,
    y1: 625,
    x2: 399.1,
    y2: 630.17
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 399.1,
    y1: 634,
    x2: 399.1,
    y2: 639.17
  }))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Women"
  }, /*#__PURE__*/React.createElement("g", {
    id: "B.G"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M909.12,813.42s-3.25,8.25-6.67,16.31-7.05,15.94-7.42,17.8c-.74,3.7-1.83,5.37,5.93,8.89,1.11.51,8.82,1.73,11.12-.74s15.58-22.24,16.32-33.36c.69-10.39,0-12.61,0-12.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M928.4,815.64a7.72,7.72,0,0,1,3.7,5.19c.89,4.43-1.48,17.06-3,19.28-.68,1-.74,11.87-.74,11.87h-3l-.44-7.81s-6.79,13.87-8.46,16c-3,3.71-9.64,11.12-25.21,13.35-8.07,1.15-10.3,0-9.64-5.93.75-6.68,14-21.56,13.35-20-1.48,3.7,1.48,7.41,6.67,8.15,1.47.21,9.79.87,10.38,0,8.16-11.86,15.71-30.95,16.32-34.85S928.4,815.64,928.4,815.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M957.31,814.9s-4.44,37.08-5.93,40c-1.36,2.74,1.49,18.54,1.49,18.54l21.5-5.93,5.19-17.8-.74-19.28-3-7.41V814.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M975.85,823.06a40.56,40.56,0,0,1,2.23,10.38,110.61,110.61,0,0,1-.75,19.28c-.49,4-1.48,12.6-14.83,12.6-9.66,0-11.86,0-10.38-11.86.4-3.19-4.66,12.55-3.7,22.24.57,5.83,6.48,7.14,8.15,7.42,6.45,1.07,17.8,0,22.25-9.64,2.57-5.57,2.22-29.66,1.48-38.56S975.85,823.06,975.85,823.06Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "992.9 529.44 986.23 817.79 949.6 817.79 936.55 529.44 992.9 529.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "936.55 529.44 934.33 817.79 897.7 817.79 879.46 529.44 936.55 529.44"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_25",
    "data-name": "Layer 25"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M991.63,565.25s2,7.19-4.66,7.19c-34.85,0-36.33-3.71-36.33,28.18,0,11.12,6.32,217.17,6.32,217.17H949.6l-11-255.19h53.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M936.3,562.6l-.49,9.1a104.66,104.66,0,0,0-31.14-.74c-5.93.74-8.56,6.44-8.9,13.35C893.9,622.21,905,750.49,908,817.79H897.7L881.58,557.68Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M989.2,407.09v14.47s4.45-10.76,36.33-.38c2.54.83-2.23-28.92-2.23-28.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M838.68,371.5l-3.34,4.25s23.45,12.63,22.62,24.67c-1.49,21.5-18.54,17.8-18.54,17.8l3,2.22,4.45.74,16.31-4.45,7.41-23L855.23,371.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M956.57,269.92s43.75,20.76,44.49,22.25,34.85,93.42,24.47,114.92c0,0-26.69-5.19-36.33,3-1.6,1.35-5.93-38.56-5.93-38.56s-1.88,5.58-5.19,8.16c-6.68,5.19,18.24,70.22,22.24,114.19,5.19,57.09-3,75.63-3,75.63s-123.08-.75-124.56-7.42c-2.94-13.21-8.7-31-6.68-66.73,2.19-38.43,19.51-97.32,20-114.19.13-4.15-5.93-6.67-7.41-16.31-.36-2.32-3.74,47.27-16.31,54.13-8.16,4.45-20,3.7-23-.74-1.3-2,2.22,4.44,11.12.74s13.35-9.64,13.35-14.83c0-4.45,1-29.66-27.44-29.66-.74,0,31.15-86.75,32.63-87.49S924,267,924,267Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_24",
    "data-name": "Layer 24"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M984.94,330s1.32,36.28-2.42,43.75-4.31,4.53-5.19,8.9c-.91,4.57,1.68,16.79,3.71,25.21,1.26,5.23,2.23,8.61,2.23,8.89,0,.74-6.68-14.08-12.61-16.31-6.4-2.4-22.24-2.22-58.58-11.86-3-.79,6.77-1.26,15.58,0C938,390,945.45,391.52,964,390c5.63-.45-8.12-10.9-9.64-13.35-1.25-2,.5,3.64,14.83.75s14.09-22.07,14.09-23.73C983.27,351.48,984.94,330,984.94,330Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M878.72,364.83s-1.78-26.87-1.82-30.3c0-2-1.11,8.45-1.15,18.44,0,7.12,1,13.48,1.15,17.29C877.24,376.69,878.72,364.83,878.72,364.83Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_23",
    "data-name": "Layer 23"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M929.51,330.35s-5.56,225-3,236.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M923.85,342.6a1.5,1.5,0,0,0,0-3,1.5,1.5,0,0,0,0,3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M922,374.79a1.5,1.5,0,0,0,0-3,1.5,1.5,0,0,0,0,3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M922.34,404.32a1.5,1.5,0,0,0,0-3,1.5,1.5,0,0,0,0,3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M921.2,437.26a1.5,1.5,0,0,0,0-3,1.5,1.5,0,0,0,0,3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M920.82,464.9a1.5,1.5,0,0,0,0-3,1.5,1.5,0,0,0,0,3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M920.45,497.84a1.5,1.5,0,0,0,0-3,1.5,1.5,0,0,0,0,3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M919.69,526.24a1.5,1.5,0,0,0,0-3,1.5,1.5,0,0,0,0,3Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M956.57,268.44s7.72,2,11.12,6.67c5.94,8.16,10.39,16.31,10.39,17.06S964.73,287,964,287s-33.37,43-34.85,43-19.28-46-19.28-48.19-15.4,1-17.8,2.22c-3,1.48.75-3.71,4.45-6.67,3.86-3.09,20-8.16,20.76-8.16s-.74,11.86-.74,11.86l13.35,40.78,27.43-46Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_30",
    "data-name": "Layer 30"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "924.42 535.33 939.53 470.56 1033.19 490.89 1016.65 553.48 924.42 535.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M940.28,471.75l91.68,19.9-16,60.67-90.3-17.77,14.66-62.8m-1.5-2.37-15.57,66.73,94.16,18.54,17.06-64.51-95.65-20.76Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-43",
    cx: 980.58,
    cy: 513.41,
    rx: 14.61,
    ry: 20.7,
    transform: "translate(254.52 1348.85) rotate(-76.64)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M989.2,420.44S977.86,493,977.33,494.59c-1.48,4.45-15.57,14.83-18.53,17.05s-8.9,17.05-8.9,17.05-3,3.71-3,4.45,8.16,2.23,12.61-9.64c.82-2.19,5.93-2.22,5.93-2.22s-5.19,19.28-5.93,20.76-2.23,11.12,5.19,5.93c0,0,2.22,5.93,5.69,1.73,1.27-1.53.24,6.43,7.66-1,1.48-1.48,1.48,3,5.19-.74,2.34-2.34,9.63-11.86,9.63-37.07,0-2.35,30.74-76.49,32.63-89.72.74-5.19-18.54-5.93-25.21-5.19C992.8,416.83,989.2,420.44,989.2,420.44Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_20",
    "data-name": "Layer 20"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M982.37,540.51c-.93,2.14-2.42,5.42-3.55,7.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M981.72,540.13c-1.1,2.52-2.22,5-3.55,7.46-.47.85.83,1.61,1.29.76,1.33-2.41,2.46-4.94,3.56-7.46a.79.79,0,0,0-.27-1,.77.77,0,0,0-1,.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M975.5,540a19.75,19.75,0,0,1-2.14,4.47,39.94,39.94,0,0,1-2.86,4.09.79.79,0,0,0,0,1.07.76.76,0,0,0,1.06,0c2.18-2.76,4.36-5.84,5.38-9.23.29-.93-1.16-1.32-1.44-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M968.08,539.25a14.16,14.16,0,0,1-1.3,4.06c-.66,1.37-1.64,2.56-2.33,3.91-.43.86.86,1.62,1.3.76.7-1.39,1.71-2.6,2.37-4a15.68,15.68,0,0,0,1.41-4.31.79.79,0,0,0-.52-.93.76.76,0,0,0-.93.53Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M747.48,312.93S769.72,330,771.21,330s18.53,3.71,20,20.76c.12,1.48,52.64,29.66,54.86,31.14s11.28,6.7,11.87,15.57c.74,11.13-3.71,23-17.06,20.77s-55.61-48.94-55.61-48.94L770.46,358.9s-6.67,1.48-10.38-4.45c0,0-6.67,0-8.15-1.48s-.74-3.71.74-3.71-3.71-1.48-3.71-3.71,1.48-1.48,2.23-2.22-.75-2.23-2.23-3,.81-3.91,3-4.45c3-.74,8.89-2.22,10.38-1.48S747.48,312.93,747.48,312.93Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_21",
    "data-name": "Layer 21"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M782.71,366.61,687.53,216,685,217.82l90.09,152.37a4.82,4.82,0,0,0,4.25.9A5.1,5.1,0,0,0,782.71,366.61Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_22",
    "data-name": "Layer 22"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M748.22,337.4s8.9-5.94,18.54-.75c2.35,1.27,1.77,3.71-2.23,3.71a3.45,3.45,0,0,1,3.71,2.23c.92,2.82-3.71,3-5.93,3.7s1.48.74,2.22.74,4.45-.74,4.45,1.49-2.22,3-3.71,3.71c-.38.19.56,1.68,1.49,3,1.34,1.88,3,3.71,3,3.71h-2.87c-1.58,0-5.62-2.56-7.51-4.45-.74-.74-5.93.74-7.41-1.48s0-3.71.74-4.45-4.45-.57-4.45-3.25,2.22-2.68,3-2.68C752.23,342.59,746.74,342.59,748.22,337.4Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_29",
    "data-name": "Layer 29"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_16",
    "data-name": "Layer 16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M954.35,232.11s4.08,37.76,3.52,42.61-22.06,47.85-28,47.85c-3.32,0-12.61-39.3-13.35-41.53s2.6-38.25,2.6-38.25Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_17",
    "data-name": "Layer 17"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M918.76,246.94,918,258.8s19.53.48,30.34-13.47a32.52,32.52,0,0,0,6-13.22C960.2,205.05,918.76,246.94,918.76,246.94Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M939.15,167.23S924,176.5,897.26,181c0,0-.75,21.5-3,26.69-1.48,5.93,2.22,28.92,26.32,41.89,6.19,3.34,33.37-4.45,39.3-26.69,1.54-5.78,1.48-17.05,1.48-20S945.82,166.49,939.15,167.23Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_18",
    "data-name": "Layer 18"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M939.52,169.82s-28.18,15.57-43.75,14.09c-1.56-.15,1.25-.89,0-1.48-11.71-5.51,21.4-17.44,21.4-17.44l25.35-5.45s20.59,30.75,19.91,35.71-2.15,6.46-2.15,6.46-4.06-7.91-8.86-15.93C947.29,178.87,942.61,171.88,939.52,169.82Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M939.52,167.6S917.29,182.43,898,182.43c-.74,0-.92,10.15-1.49,11.86-.74,2.23-.06-8.38-3-7.41-2.23.74,0,9.64.74,11.86.23.7-5.19-5.93-5.19-17.79,0-5.94-.74-37.82,43-41.53,3-.25,40.79-4.45,50.42,18.54,0,0,11.13,1.48,11.87,12.61s-4.45,31.14-14.09,35.59c-.95.44-12.61,18.53-23,23.72-.36.18,1.49-5.19,2.23-7.41,1.45-4.37,8.12-7.31,9.64-11.87.74-2.22.74-5.93,0-7.41-3.28-6.57-8.9-1.48-8.9-1.48S955.09,181.69,939.52,167.6Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_11",
    "data-name": "Layer 11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M958.06,221c3.7,1.48,10.38-7.42,11.12-10.39s1.69-8.47-1.49-10.38c-3.7-2.22-7.41.75-8.89,2.23S958.06,221,958.06,221Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_14",
    "data-name": "Layer 14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M961.89,206.49c.82-.18,1.88-.44,2.45.37a4.55,4.55,0,0,1,.35,3,8.27,8.27,0,0,1-1.34,2.81l-1.73,3.11a.75.75,0,0,0,1.29.75l2.18-3.9a12.17,12.17,0,0,0,.89-1.72,5.75,5.75,0,0,0,.25-1.94,4.26,4.26,0,0,0-1.12-3.44c-1-.9-2.39-.72-3.62-.44-.94.21-.54,1.66.4,1.44Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_12",
    "data-name": "Layer 12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M929.14,198s5.19-2.22,8.15-2.22,5.94,2.22,7.42,3,0-1.48-4.45-4.45c-3.6-2.4-12.41,1-13.35,1.49-1.48.74-.39,3.1,0,3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M911.42,198s-5-2.16-7.92-2.16-5.76,2.16-7.2,2.88,0-1.44,4.32-4.32c3.49-2.33,12,1,13,1.44,1.43.72.38,3,0,2.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M916.75,209s-5.23,9.33-5.11,10.81,3.69,1.91,8.36,2.33c4.49.4-6.09-1.76-6.2-3.24C913.67,217.28,917.55,209.72,916.75,209Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_13",
    "data-name": "Layer 13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M938.86,202.54s.41-1.4-.08-1.57a12.79,12.79,0,0,0-5.93-.75,10.82,10.82,0,0,0-5.54,2.52c-.4.45,1.74.13,2.62.08s1.25-.15,3-.34c2.43-.28,4.2.6,5.16.71C938.53,203.25,938.86,202.54,938.86,202.54Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-49",
    cx: 934.33,
    cy: 205.23,
    rx: 2.97,
    ry: 4.26
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M909.94,202.54s.41-1.4-.08-1.57a12.79,12.79,0,0,0-5.93-.75,10.77,10.77,0,0,0-5.53,2.52c-.4.45,1.73.13,2.62.08s1.24-.15,2.94-.34c2.43-.28,4.2.6,5.16.71C909.61,203.25,909.94,202.54,909.94,202.54Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-49",
    cx: 905.41,
    cy: 205.23,
    rx: 2.97,
    ry: 4.26
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_15",
    "data-name": "Layer 15"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M928.4,224.69c0,1-.16,3.36-2.23,6.68-3.7,5.93-10,4.84-12.6,2.22-3-3-3.63-5.12-3.71-5.93a27.39,27.39,0,0,0,8.9.74A20.07,20.07,0,0,0,928.4,224.69Z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlatChartG01);
export default __webpack_public_path__ + "static/media/FlatChartG01.5dfb756ddd364b1f23c95fdb51238632.svg";
export { ForwardRef as ReactComponent };